import React from "react";
import ReactDOM from "react-dom";
import LoadingIndicator from "./utils/promiseTracker/LoadingIndicator";
import "./index.css";
import App from "./App";
import {
	AuthContextProvider,
	DependentsContextProvider,
	GroupContextProvider,
	GroupOwnerContextProvider,
	PaycheckContextProvider,
	ThemeContextProvider
} from "./contexts";
import { BrowserRouter } from "react-router-dom";
import { store } from "./app/store";
import { Provider } from "react-redux";
ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<AuthContextProvider>
				<PaycheckContextProvider>
					<GroupContextProvider>
						<DependentsContextProvider>
							<GroupOwnerContextProvider>
								<ThemeContextProvider>
									<LoadingIndicator />
									<BrowserRouter>
										<App />
									</BrowserRouter>
								</ThemeContextProvider>
							</GroupOwnerContextProvider>
						</DependentsContextProvider>
					</GroupContextProvider>
				</PaycheckContextProvider>
			</AuthContextProvider>
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
